module.exports = __webpack_public_path__ + "img/subject_select_text.db0180cf.svg";